import { PortfolioUtilities as portfolioUtilities, PortfolioUtilities } from '@common/portfolio.utilities';
import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import * as _ from 'lodash';


class PorfolioAdminCashTxnController implements angular.IOnInit {

  public clientId: number;
  public selectedPortfolioIds: Array<number>;

  public accounts: Array<any>;

  /** @ngInject */
  constructor(private portfolioUtilities:PortfolioUtilities ,private portfolioRepo: portfolioRepo) {

  }

  $onInit() {
    this.loadAccounts();
  }

  $onChanges(changes) {
    if (changes.selectedPortfolioIds) {
      this.loadAccounts();
    }
  }

  loadAccounts() {
    if (!this.selectedPortfolioIds || this.selectedPortfolioIds.length === 0) {
      return;
    }
    
    this.portfolioRepo.getPortfolioCashAccounts(this.selectedPortfolioIds)
      .then((results) => {
        // Order accounts
        this.accounts = [];
        let accounts = results.data as Array<any>;
        accounts = _.orderBy(accounts, (a) => { return a.currency });
        this.accounts.push(...accounts);
      });
  }

  getData = (accountNumber) => {
    return this.portfolioRepo.getCashAccountTransactions(accountNumber);
  }

  formatCurrency(currency) {

    return this.portfolioUtilities.formatCurrency(currency);
  }


}


export const portfolioCashTransactions: angular.IComponentOptions = {
  template: require('./portfolioadmin.cashTransactions.html'),
  controller: PorfolioAdminCashTxnController,
  bindings: {
    clientId: "<",
    selectedPortfolioIds: "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/cashTransactions/portfolioadmin.cashTransactions.ts